import i18n from '@/i18n.js'

export default {
  actions: [],

  tableHeaders: [
    {text: 'Icon', value: 'default_icon_id', sortable: false},
    {text: 'Title', value: 'action_title'},
    {text: 'Tenant', value: 'tenant_id'},
    {text: 'Actions', value: 'actions', sortable: false}
  ],

  selectedAction: {},

  fields: [
    {
      name: 'action_title',
      type: 'text',
      label: 'Action Title',
      rules: [
        v => !!v || i18n.t('form_rules.mandatory')
      ],
      autofocus: true,
      required: true,
      hide: false,
      value: null
    },
    {
      name: 'action_key',
      type: 'text',
      label: 'Action Key',
      rules: [
        v => !!v || i18n.t('form_rules.mandatory'),
        v => /^[a-z0-9_]+$/.test(v) || 'Only lowercase letters, numbers and underscore allowed'
      ],
      required: true,
      hide: false,
      value: null,
      hint: 'Only lowercase letters, numbers and underscore (_) allowed'
    },
    {
      name: 'tenant_id',
      type: 'select',
      label: 'Tenant',
      items: [],
      itemText: 'title',
      itemValue: 'tenant_id',
      required: false,
      hide: false,
      chips: true,
      multiple: false,
      rules: [],
      value: null
    },
    {
      name: 'pipeline_id',
      type: 'number',
      label: 'Pipeline ID',
      required: false,
      hide: false,
      value: null,
    },
    {
      name: 'default_icon_id',
      type: 'number',
      label: 'Default Icon ID',
      required: false,
      hide: false,
      value: null,
    },
    {
      name: 'fieldset_id',
      type: 'hidden',
      value: null,
      hide: true
    },
    {
      name: 'built_in',
      type: 'hidden',
      value: false,
      hide: true
    },
    {
      name: 'action_url',
      type: 'hidden',
      value: '127.0.0.1',
      hide: true
    }
  ]
}
